/* eslint-disable eqeqeq, no-unused-vars */

const SLEEPIZ = "sleepiz";
const CE_SLEEPIZ = "ce_sleepiz";

const default_config = {
    site_url: "https://sleepiz.io",
    site_version: "4.3.10",
    home_url: "https://www.sleepiz.com",
    url: "https://www.sleepiz.com",
    base_url: "",
    version: "0.0.0",
    api_version: "v1",
    auth_keys: {
        DEFAULT_TOKEN: "",
        MIXPANEL_TOKEN: "",
        GOOGLE_TOKEN: "",
        SENTRY_DSN:
            "ec14747568e44f3f8746df337ce467f522eb8b6dc19b4fd794f016d47cf13eb6",
    },
    instance: SLEEPIZ,
};

const default_ce_config = {
    site_url: "https://med.sleepiz.app",
    site_version: "1.1",
    home_url: "https://www.sleepiz.com",
    url: "https://www.sleepiz.com",
    base_url: "",
    version: "0.0.0",
    api_version: "v1",
    auth_keys: {
        DEFAULT_TOKEN: "",
        MIXPANEL_TOKEN: "",
        GOOGLE_TOKEN: "",
        SENTRY_DSN:
            "ec14747568e44f3f8746df337ce467f522eb8b6dc19b4fd794f016d47cf13eb6",
    },
    instance: CE_SLEEPIZ,
};

const LOCAL_ENV = "local";
const LOCAL_SITE_URL = "http://localhost:3000";
const LOCAL_BUILD_SITE_URL = "http://local.sleepiz.io";
const LOCAL_API_URL = "http://localhost:4000";
const LOCAL_DEVICE_CONFIG_URL = "http://localhost:4000";

const TEST_ENV = "test";
const TEST_SITE_URL = "https://test.sleepiz.app";
const TEST_API_URL = TEST_SITE_URL + "/api";
const TEST_REAL_TIME_SOCKET_URL = "https://test.sleepiz.app/stream";

const RELEASE_ENV = "release";
const RELEASE_SITE_URL = "https://release.sleepiz.app";
const RELEASE_API_URL = RELEASE_SITE_URL + "/api";
const RELEASE_REAL_TIME_SOCKET_URL = "https://release.sleepiz.app/stream";
const RELEASE_DEVICE_CONFIG_URL = "https://release.sleepiz.app";

const PROD_ENV = "prod";
const PROD_SITE_URL = "https://sleepiz.io";
const PROD_API_URL = PROD_SITE_URL + "/api";
const PROD_REAL_TIME_SOCKET_URL = "https://sleepiz.io/stream";

const PROD_CE_ENV = "prodce";
const PROD_CE_SITE_URL = "https://med.sleepiz.app";
const PROD_CE_API_URL = PROD_CE_SITE_URL + "/api";
const PROD_CE_REAL_TIME_SOCKET_URL = "https://med.sleepiz.app/stream";
const PROD_CE_DEVICE_CONFIG_URL = "https://sleepiz.io";

const local_config = {
    env: LOCAL_ENV,
    api_url: LOCAL_API_URL,
    rt_socket_url: TEST_REAL_TIME_SOCKET_URL,
    show_site_version: true,
    device_config_url: LOCAL_DEVICE_CONFIG_URL,
    insomnia_url: PROD_CE_SITE_URL,
};

const test_config = {
    env: TEST_ENV,
    api_url: TEST_API_URL,
    rt_socket_url: TEST_REAL_TIME_SOCKET_URL,
    show_site_version: true,
    device_config_url: RELEASE_DEVICE_CONFIG_URL,
    insomnia_url: PROD_CE_SITE_URL,
};

const release_config = {
    env: RELEASE_ENV,
    api_url: RELEASE_API_URL,
    rt_socket_url: RELEASE_REAL_TIME_SOCKET_URL,
    show_site_version: true,
    device_config_url: RELEASE_DEVICE_CONFIG_URL,
    insomnia_url: PROD_SITE_URL,
};

const prod_config = {
    env: PROD_ENV,
    api_url: PROD_API_URL,
    rt_socket_url: PROD_REAL_TIME_SOCKET_URL,
    show_site_version: true,
    device_config_url: PROD_API_URL,
    insomnia_url: PROD_SITE_URL,
};

const prod_ce_config = {
    env: PROD_CE_ENV,
    api_url: PROD_CE_API_URL,
    rt_socket_url: PROD_CE_REAL_TIME_SOCKET_URL,
    show_site_version: true,
    device_config_url: PROD_CE_API_URL,
    insomnia_url: PROD_CE_SITE_URL,
};

let site_config;
let env_config;
const origin = window.location.origin;

if ([LOCAL_SITE_URL, LOCAL_BUILD_SITE_URL].includes(origin)) {
    site_config = default_config;
    env_config = prod_ce_config;
} else if (
    origin === TEST_SITE_URL ||
    origin === "https://www.test.sleepiz.app"
) {
    site_config = default_config;
    env_config = test_config;
} else if (
    origin === RELEASE_SITE_URL ||
    origin === "https://www.release.sleepiz.app"
) {
    site_config = default_config;
    env_config = release_config;
} else if (origin === PROD_SITE_URL || origin === "https://www.sleepiz.io") {
    site_config = default_config;
    env_config = prod_config;
} else if (origin === PROD_CE_SITE_URL) {
    site_config = default_ce_config;
    env_config = prod_ce_config;
} else {
    env_config = local_config;
}

export default {
    ...site_config,
    ...env_config,
    SLEEPIZ,
    CE_SLEEPIZ,
};
